import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { addRegionAPI, addSlotsDaysAPI, addSubRegionAPI, deleteRegionAPI, deleteSubRegionAPI, deleteTimeSlotAPI, exportSlotDataAPI, fetchEmployeesListAPI, fetchLogCanpayAPI, fetchSlotLogsAPI, fetchTimeSlotDataAPI, fetchUpdateStatusAPI, getPackageTimeAPI, getProcessTimeAPI, getRegionAPI, getRegionDetailsAPI, getServiceTimeAPI, getSlotsDaysAPI, getSubRegionAPI, getSubRegionDetailsAPI, gettransactionsListAPI, getUnassignedDriversAPI, getUnassignedSubRegionAPI, slotRollBackDataAPI, unassignDriversAPI, unassignSubRegionAPI, updateAssignedSubRegionAPI, updatePackageTimeAPI, updateProcessTimeAPI, UpdateRefundStatusAPI, updateRegionAPI, updateServiceTimeAPI, updateSlotsDaysAPI, updateStatusAPI, updateSubRegionAPI, CreateBRBAPI, CreateHolidayManagementAPI, CreateShopTimingAPI, deleteBrbGraphicsByIdAPI, deleteHolidaySlotAPI, deleteShopTimeSlotAPI, EditShopTimingApi, fetchBRBByIDApi, fetchBRBGraphicsLogsAPI, fetchBRBListAPI, fetchDayWiseSlotsApi, fetchHolidayByIDApi, fetchHolidaysListAPI, fetchHolidaysLogsAPI, fetchShopSlotLogsAPI, fetchShopTimeListAPI, updateBRBByIDApi, updateHolidayByIDApi, getBlazeRegionsAPI, } from '../../apis/hyperwolf/settings'


export const getServiceTime = createAsyncThunk(
  'drivers/getServiceTime',
  async (filters, { rejectWithValue }) => {
    try {
      const res = await getServiceTimeAPI(filters)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

export const updateServiceTime = createAsyncThunk(
  'drivers/updateServiceTime',
  async (data, { rejectWithValue }) => {
    try {
      const res = await updateServiceTimeAPI(data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

export const getProcessTime = createAsyncThunk(
  'drivers/getProcessTime',
  async (filters, { rejectWithValue }) => {
    try {
      const res = await getProcessTimeAPI(filters)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

export const getPackageTime = createAsyncThunk(
  'drivers/getPackageTime',
  async (filters, { rejectWithValue }) => {
    try {
      const res = await getPackageTimeAPI(filters)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

export const updateProcessTime = createAsyncThunk(
  'drivers/updateProcessTime',
  async (data, { rejectWithValue }) => {
    try {
      const res = await updateProcessTimeAPI(data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

export const updatePackageTime = createAsyncThunk(
  'drivers/updatePackageTime',
  async (data, { rejectWithValue }) => {
    try {
      const res = await updatePackageTimeAPI(data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

export const updateStatus = createAsyncThunk(
  'drivers/updateStatus',
  async (data, { rejectWithValue }) => {
    try {
      const res = await updateStatusAPI(data)
      return res?.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const fetchUpdateStatus = createAsyncThunk(
  'drivers/fetchUpdateStatus',
  async (data, { rejectWithValue }) => {
    try {
      const res = await fetchUpdateStatusAPI(data)
      return res?.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

export const gettransactionsList = createAsyncThunk(
  'drivers/gettransactionsList',
  async (data, { rejectWithValue }) => {
    try {
      const res = await gettransactionsListAPI(data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const UpdateRefundStatus = createAsyncThunk(
  'drivers/UpdateRefundStatus',
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await UpdateRefundStatusAPI(data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

export const fetchEmployeesList = createAsyncThunk(
  'common/fetchEmployeesList',
  async (data, { rejectWithValue }) => {
    try {
      const res = await fetchEmployeesListAPI(data);
      return res
    } catch (error) {
      return rejectWithValue(error.response?.data)
    }
  }
)

export const fetchLogCanpay = createAsyncThunk(
  'drivers/fetchLogCanpay',
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await fetchLogCanpayAPI(data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const fetchTimeSlotData = createAsyncThunk(
  'setting/timeSlot',
  async (data, { rejectWithValue }) => {
    try {
      const res = await fetchTimeSlotDataAPI(data)
      return res?.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

export const fetchSlotLogs = createAsyncThunk(
  'setting/fetchSlotLogs',
  async (data, { rejectWithValue }) => {
    try {
      const res = await fetchSlotLogsAPI(data)
      return res?.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const slotRollBackData = createAsyncThunk(
  'setting/slotRollBackData',
  async (data, { rejectWithValue }) => {
    try {
      const res = await slotRollBackDataAPI(data)
      return res?.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

export const exportSlotData = createAsyncThunk(
  'setting/exportSlotData',
  async (data, { rejectWithValue }) => {
    try {
      const res = await exportSlotDataAPI(data)
      return res?.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

export const addSlotsDays = createAsyncThunk(
  'setting/addSlotsDays',
  async (data, { rejectWithValue }) => {
    try {
      const res = await addSlotsDaysAPI(data)
      return res?.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)


export const updateSlotsDays = createAsyncThunk(
  'setting/updateSlotsDays',
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const res = await updateSlotsDaysAPI(data, id)
      return res?.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

export const deleteTimeSlot = createAsyncThunk(
  'members/deleteTimeSlot',
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const res = await deleteTimeSlotAPI(id, payload)
      return res
    } catch (error) {

      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getSlotsDays = createAsyncThunk(
  'setting/getSlotsDays',
  async (data, { rejectWithValue }) => {

    try {
      const res = await getSlotsDaysAPI(data)
      return res?.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
);

// sub regions
export const addSubRegion = createAsyncThunk(
  'setting/addSubRegion',
  async (data, { rejectWithValue }) => {
    try {
      const res = await addSubRegionAPI(data)
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
);
export const getSubRegions = createAsyncThunk(
  'setting/getSubRegions',
  async (data, { rejectWithValue }) => {
    try {
      const res = await getSubRegionAPI(data)
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
);
export const getUnassignedSubRegion = createAsyncThunk(
  'setting/getUnassignedSubRegion',
  async (data, { rejectWithValue }) => {
    try {
      const res = await getUnassignedSubRegionAPI(data)
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
);
export const getUnassignedDrivers = createAsyncThunk(
  'setting/getUnassignedDrivers',
  async (data, { rejectWithValue }) => {
    try {
      const res = await getUnassignedDriversAPI(data)
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
);
export const getSubRegionDetails = createAsyncThunk(
  'setting/getSubRegionDetails',
  async (data, { rejectWithValue }) => {
    try {
      const res = await getSubRegionDetailsAPI(data)
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
);
export const getBlazeRegions = createAsyncThunk(
  'setting/getBlazeRegions',
  async (data, { rejectWithValue }) => {
    try {
      const res = await getBlazeRegionsAPI(data)
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
);
export const updateSubRegion = createAsyncThunk(
  'setting/updateSubRegion',
  async (data, { rejectWithValue }) => {
    try {
      const res = await updateSubRegionAPI(data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
);
export const deleteSubRegion = createAsyncThunk(
  'setting/deleteSubRegion',
  async (data, { rejectWithValue }) => {
    try {
      const res = await deleteSubRegionAPI(data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
);


// regions
export const addRegion = createAsyncThunk(
  'setting/addRegion',
  async (data, { rejectWithValue }) => {
    try {
      const res = await addRegionAPI(data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
);
export const getRegions = createAsyncThunk(
  'setting/getRegions',
  async (data, { rejectWithValue }) => {
    try {
      const res = await getRegionAPI(data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
);
export const getRegionDetails = createAsyncThunk(
  'setting/getRegionDetails',
  async (data, { rejectWithValue }) => {
    try {
      const res = await getRegionDetailsAPI(data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
);
export const updateRegion = createAsyncThunk(
  'setting/updateRegion',
  async (data, { rejectWithValue }) => {
    try {
      const res = await updateRegionAPI(data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
);
export const deleteRegion = createAsyncThunk(
  'setting/deleteRegion',
  async (data, { rejectWithValue }) => {
    try {
      const res = await deleteRegionAPI(data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
);
export const unassignSubRegion = createAsyncThunk(
  'setting/unassignSubRegion',
  async (data, { rejectWithValue }) => {
    try {
      const res = await unassignSubRegionAPI(data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
);

export const unassignDrivers = createAsyncThunk(
  'setting/unassignDrivers',
  async (data, { rejectWithValue }) => {
    try {
      const res = await unassignDriversAPI(data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
);

export const updateAssignedSubRegion = createAsyncThunk(
  'setting/updateAssignedSubRegion',
  async (data, { rejectWithValue }) => {
    try {
      const res = await updateAssignedSubRegionAPI(data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
);
export const fetchHolidaysList = createAsyncThunk(
  'setting/fetchHolidaysList',
  async (data, { rejectWithValue }) => {

    try {
      const res = await fetchHolidaysListAPI(data)
      return res?.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const fetchBRBList = createAsyncThunk(
  'setting/fetchBRBList',
  async (data, { rejectWithValue }) => {

    try {
      const res = await fetchBRBListAPI(data)
      return res?.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

export const fetchBRBByID = createAsyncThunk(
  'setting/fetchBRBByID',
  async (data, { rejectWithValue }) => {

    try {
      const res = await fetchBRBByIDApi(data)
      return res?.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

export const fetchHolidayByID = createAsyncThunk(
  'setting/fetchHolidayByID',
  async (data, { rejectWithValue }) => {

    try {
      const res = await fetchHolidayByIDApi(data)
      return res?.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const fetchShopTimeList = createAsyncThunk(
  'setting/fetchShopTimeList',
  async (data, { rejectWithValue }) => {

    try {
      const res = await fetchShopTimeListAPI(data)
      return res?.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

export const fetchShopSlotLogs = createAsyncThunk(
  'setting/fetchShopSlotLogs',
  async (data, { rejectWithValue }) => {

    try {
      const res = await fetchShopSlotLogsAPI(data)
      return res?.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

export const CreateShopTiming = createAsyncThunk(
  'setting/CreateShopTiming',
  async (data, { rejectWithValue }) => {

    try {
      const res = await CreateShopTimingAPI(data)
      return res?.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const EditShopTiming = createAsyncThunk(
  'setting/EditShopTiming',
  async ({ payloads, editid }, { rejectWithValue }) => {

    try {
      const res = await EditShopTimingApi(payloads, editid)
      return res?.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const CreateBRBGraphic = createAsyncThunk(
  'setting/CreateBRBGraphic',
  async (data, { rejectWithValue }) => {

    try {
      const res = await CreateBRBAPI(data)
      return res?.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

export const CreateHolidayManagement = createAsyncThunk(
  'setting/CreateHolidayManagement',
  async (data, { rejectWithValue }) => {

    try {
      const res = await CreateHolidayManagementAPI(data)
      return res?.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

export const deleteShopTimeSlot = createAsyncThunk(
  'members/deleteShopTimeSlot',
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const res = await deleteShopTimeSlotAPI(id, payload)
      return res
    } catch (error) {

      return rejectWithValue(error?.response?.data)
    }
  }
)
export const fetchHolidaysLogs = createAsyncThunk(
  'setting/fetchHolidaysLogs',
  async (data, { rejectWithValue }) => {

    try {
      const res = await fetchHolidaysLogsAPI(data)
      return res?.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

export const deleteHolidaySlot = createAsyncThunk(
  'members/deleteHolidaySlot',
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const res = await deleteHolidaySlotAPI(id, payload)
      return res
    } catch (error) {

      return rejectWithValue(error?.response?.data)
    }
  }
)
export const fetchBRBGraphicsLogs = createAsyncThunk(
  'setting/fetchBRBGraphicsLogs',
  async (data, { rejectWithValue }) => {

    try {
      const res = await fetchBRBGraphicsLogsAPI(data)
      return res?.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

export const updateBRBByID = createAsyncThunk(
  'setting/updateBRBByID',
  async ({ payload, brbID }, { rejectWithValue }) => {

    try {
      const res = await updateBRBByIDApi(payload, brbID)
      return res?.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const deleteBrbGraphicsById = createAsyncThunk(
  'members/deleteBrbGraphicsById',
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const res = await deleteBrbGraphicsByIdAPI(id, payload)
      return res
    } catch (error) {

      return rejectWithValue(error?.response?.data)
    }
  }
)
export const updateHolidayByID = createAsyncThunk(
  'setting/updateHolidayByID',
  async ({ payload, holidayID }, { rejectWithValue }) => {

    try {
      const res = await updateHolidayByIDApi(payload, holidayID)
      return res?.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

export const fetchDayWiseSlots = createAsyncThunk(
  'setting/fetchDayWiseSlots',
  async (data, { rejectWithValue }) => {

    try {
      const res = await fetchDayWiseSlotsApi(data)
      return res?.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
const hyperwolfSettings = createSlice({
  name: ' hyperwolfSettings',
  initialState: {
    isLoading: false,
    isgetLoading: false,
    islogLoading: false,
    serviceTime: {},
    processTime: {},
    packageTime: {},
    error: null,
    timeSlots: [],
    logsloading: false,
    isfetchLoading: false,
    loading: false,
    isUnassignDriversLoading: false,

  },
  reducers: {

  },
  extraReducers: (builder) => {
    builder
      .addCase(getServiceTime.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getServiceTime.fulfilled, (state, action) => {
        state.isLoading = false;
        state.serviceTime = action.payload;
      })
      .addCase(getServiceTime.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload
      })
      .addCase(updateServiceTime.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateServiceTime.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateServiceTime.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload
      })


    builder
      .addCase(getProcessTime.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getProcessTime.fulfilled, (state, action) => {
        state.isLoading = false;
        state.processTime = action.payload;
      })
      .addCase(getProcessTime.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload
      })
      .addCase(updateProcessTime.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateProcessTime.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateProcessTime.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload
      })



    builder
      .addCase(getPackageTime.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getPackageTime.fulfilled, (state, action) => {
        state.isLoading = false;
        state.packageTime = action.payload;
      })
      .addCase(getPackageTime.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload
      })
      .addCase(updatePackageTime.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updatePackageTime.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updatePackageTime.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload
      })

    builder
      .addCase(updateStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateStatus.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateStatus.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(fetchUpdateStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchUpdateStatus.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(fetchUpdateStatus.rejected, (state, action) => {
        state.isLoading = false;
      })

    builder
      .addCase(gettransactionsList.pending, (state) => {
        state.isgetLoading = true;
        state.transactionsList = {}
      })
      .addCase(gettransactionsList.fulfilled, (state, action) => {
        state.isgetLoading = false;
        state.transactionsList = action.payload?.data;
      })
      .addCase(gettransactionsList.rejected, (state, action) => {
        state.isgetLoading = false;
        state.transactionsList = {}
      })
    builder
      .addCase(UpdateRefundStatus.pending, (state) => {
        state.isgetLoading = true;
      })
      .addCase(UpdateRefundStatus.fulfilled, (state, action) => {
        state.isgetLoading = false;
      })
      .addCase(UpdateRefundStatus.rejected, (state, action) => {
        state.isgetLoading = false;
      })
    builder
      .addCase(fetchEmployeesList.pending, (state) => {
        state.isgetLoading = true;
      })
      .addCase(fetchEmployeesList.fulfilled, (state, action) => {
        state.isgetLoading = false;
        state.employeeData = action.payload?.data?.employees || [];
      })
      .addCase(fetchEmployeesList.rejected, (state, action) => {
        state.isgetLoading = false;
      })
    builder
      .addCase(fetchLogCanpay.pending, (state) => {
        state.islogLoading = true;
      })
      .addCase(fetchLogCanpay.fulfilled, (state, action) => {
        state.islogLoading = false;
      })
      .addCase(fetchLogCanpay.rejected, (state, action) => {
        state.islogLoading = false;
      })
    builder
      .addCase(fetchTimeSlotData.pending, (state) => {
        state.isfetchLoading = true;
        state.error = null;
      })
      .addCase(fetchTimeSlotData.fulfilled, (state, action) => {
        state.isfetchLoading = false;
        state.timeSlots = action.payload;
      })
      .addCase(fetchTimeSlotData.rejected, (state, action) => {
        state.isfetchLoading = false;
        state.error = action.payload || 'Failed to fetch time slots';
      });

    builder
      .addCase(fetchSlotLogs.pending, (state) => {
        state.logsloading = true;
        state.error = null;
      })
      .addCase(fetchSlotLogs.fulfilled, (state, action) => {
        state.logsloading = false;
        state.slotsLogs = action.payload;
      })
      .addCase(fetchSlotLogs.rejected, (state, action) => {
        state.logsloading = false;
        state.error = action.payload
      });
    builder
      .addCase(exportSlotData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(exportSlotData.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(exportSlotData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload
      });
    builder
      .addCase(addSlotsDays.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(addSlotsDays.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(addSlotsDays.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload
      });
    builder
      .addCase(updateSlotsDays.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateSlotsDays.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateSlotsDays.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload
      });
    builder
      .addCase(deleteTimeSlot.pending, (state, action) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteTimeSlot.fulfilled, (state, action) => {
        state.isLoading = false;
        // You can update your state with the data received from the API if needed
      })
      .addCase(deleteTimeSlot.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload; // The error message returned from the API
      });

    builder
      .addCase(getSlotsDays.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getSlotsDays.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(getSlotsDays.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload
      });
    builder
      .addCase(slotRollBackData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(slotRollBackData.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(slotRollBackData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload
      });
    // fetchHolidaysList
    builder
      .addCase(fetchHolidaysList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchHolidaysList.fulfilled, (state, action) => {
        state.loading = false;
        state.holidayData = action.payload
      })
      .addCase(fetchHolidaysList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload
      });

    builder
      .addCase(fetchBRBList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBRBList.fulfilled, (state, action) => {
        state.loading = false;
        state.brbData = action.payload
      })
      .addCase(fetchBRBList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload
      });
    builder
      .addCase(fetchShopTimeList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchShopTimeList.fulfilled, (state, action) => {
        state.loading = false;
        state.shopTimingData = action.payload
      })
      .addCase(fetchShopTimeList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload
      });

    builder
      .addCase(fetchShopSlotLogs.pending, (state) => {
        state.logsloading = true;
        state.error = null;
      })
      .addCase(fetchShopSlotLogs.fulfilled, (state, action) => {
        state.logsloading = false;
        state.slotsLogs = action.payload;
      })
      .addCase(fetchShopSlotLogs.rejected, (state, action) => {
        state.logsloading = false;
        state.error = action.payload
      });
    builder
      .addCase(CreateShopTiming.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(CreateShopTiming.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(CreateShopTiming.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
    builder
      .addCase(EditShopTiming.pending, (state) => {
        state.isUpdateLoading = true;
        state.error = null;
      })
      .addCase(EditShopTiming.fulfilled, (state, action) => {
        state.isUpdateLoading = false;
      })
      .addCase(EditShopTiming.rejected, (state, action) => {
        state.isUpdateLoading = false;
        state.error = action.payload;
      });
    builder
      .addCase(CreateBRBGraphic.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(CreateBRBGraphic.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(CreateBRBGraphic.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
    builder
      .addCase(CreateHolidayManagement.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(CreateHolidayManagement.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(CreateHolidayManagement.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
    builder
      .addCase(fetchBRBByID.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchBRBByID.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(fetchBRBByID.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
    builder
      .addCase(fetchHolidayByID.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchHolidayByID.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(fetchHolidayByID.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
    builder
      .addCase(fetchHolidaysLogs.pending, (state) => {
        state.logsloading = true;
        state.error = null;
      })
      .addCase(fetchHolidaysLogs.fulfilled, (state, action) => {
        state.logsloading = false;
        state.slotsLogs = action.payload;
      })
      .addCase(fetchHolidaysLogs.rejected, (state, action) => {
        state.logsloading = false;
        state.error = action.payload
      });

    builder
      .addCase(fetchBRBGraphicsLogs.pending, (state) => {
        state.logsloading = true;
        state.error = null;
      })
      .addCase(fetchBRBGraphicsLogs.fulfilled, (state, action) => {
        state.logsloading = false;
        state.slotsLogs = action.payload;
      })
      .addCase(fetchBRBGraphicsLogs.rejected, (state, action) => {
        state.logsloading = false;
        state.error = action.payload
      });

    builder
      .addCase(updateBRBByID.pending, (state) => {
        state.isUpdateLoading = true;
        state.error = null;
      })
      .addCase(updateBRBByID.fulfilled, (state, action) => {
        state.isUpdateLoading = false;
      })
      .addCase(updateBRBByID.rejected, (state, action) => {
        state.isUpdateLoading = false;
        state.error = action.payload;
      })
    builder
      .addCase(updateHolidayByID.pending, (state) => {
        state.isUpdateLoading = true;
        state.error = null;
      })
      .addCase(updateHolidayByID.fulfilled, (state, action) => {
        state.isUpdateLoading = false;
      })
      .addCase(updateHolidayByID.rejected, (state, action) => {
        state.isUpdateLoading = false;
        state.error = action.payload;
      })
    builder
      .addCase(fetchDayWiseSlots.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchDayWiseSlots.fulfilled, (state, action) => {
        state.isLoading = false;
        state.daySlotsData = action.payload;

      })
      .addCase(fetchDayWiseSlots.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

    builder
      .addCase(unassignDrivers.pending, (state) => {
        state.isUnassignDriversLoading = true;
        state.error = null;
      })
      .addCase(unassignDrivers.fulfilled, (state) => {
        state.isUnassignDriversLoading = false;
      })
      .addCase(unassignDrivers.rejected, (state, action) => {
        state.isUnassignDriversLoading = false;
        state.error = action.payload;
      })
  }
})

export const { } = hyperwolfSettings.actions;

export default hyperwolfSettings.reducer;